/** USD display with en-US grouping; minus precedes the symbol (e.g. -$13,342.86). */
export function formatCurrencyDisplay(value: number, currencySymbol = '$'): string {
	if (currencySymbol === '$') {
		return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
	}

	const absFormatted = Math.abs(value).toLocaleString('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
	return value < 0 ? `-${currencySymbol}${absFormatted}` : `${currencySymbol}${absFormatted}`;
}

/** Bidi isolate for currency embedded in plain-text strings (MessageBox, templates). */
export function wrapCurrencyBidi(text: string): string {
	return `\u2068${text}\u2069`;
}
